import type * as store from '@attain-apps/fe/web/main/lib/store'

import type { Plugin } from './plugin'
import type { State } from './state'

/**
 * Core actions for this {@link Plugin}
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  // NOTE: no actions needed at the moment
  return {} as const satisfies store.actions.Config.Constraint<State>
}
